export default "__VITE_PUBLIC_ASSET__ea025f39__"